import {
  Activity,
  Clock3,
  Gauge,
  MapPin,
  RefreshCw,
  ShoppingBag,
  Sparkles,
  Target,
  Users,
  WalletCards,
} from "lucide-react";

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="border-l border-purple-400/40 pl-3" data-testid={testId}>
    <div className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.18em] text-zinc-500"><Icon size={12} />{label}</div>
    <div className="mt-2 text-sm font-semibold leading-snug text-white">{value}</div>
  </div>
);

const Detail = ({ icon: Icon, label, children, testId }) => (
  <div className="border-t border-zinc-800 py-4" data-testid={testId}>
    <div className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.18em] text-purple-300"><Icon size={12} />{label}</div>
    <p className="mt-2 text-sm leading-relaxed text-zinc-300">{children}</p>
  </div>
);

export const OpportunityProfilePanel = ({ profile, compact = false }) => {
  if (!profile) return null;
  return (
    <section className="mt-10 border border-zinc-800 bg-[#08070a]" data-testid="opportunity-profile-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-zinc-800 px-5 py-4 sm:px-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-amber-300">Commercial opportunity profile</div>
          <div className="mt-1 text-sm text-zinc-400">{profile.business_type} · {profile.activity_model}</div>
        </div>
        {profile.score_total && <div className="border border-amber-400/30 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.16em] text-amber-200" data-testid="opportunity-score">Research score · {profile.score_total}/120</div>}
      </div>

      <div className="grid grid-cols-2 gap-x-5 gap-y-6 px-5 py-5 sm:grid-cols-4 sm:px-6">
        <Stat icon={Clock3} label="Launch" value={profile.time_to_launch} testId="opportunity-launch-time" />
        <Stat icon={WalletCards} label="Startup" value={profile.startup_cost} testId="opportunity-startup-cost" />
        <Stat icon={Gauge} label="Speed" value={profile.monetisation_speed} testId="opportunity-speed" />
        <Stat icon={Activity} label="Difficulty" value={profile.difficulty} testId="opportunity-difficulty" />
      </div>

      <div className="grid border-t border-zinc-800 px-5 sm:grid-cols-2 sm:gap-x-8 sm:px-6">
        <div>
          <Detail icon={Users} label="Who it is for" testId="opportunity-who-for">{profile.who_for}</Detail>
          <Detail icon={ShoppingBag} label="What you sell" testId="opportunity-what-sell">{profile.what_you_sell}</Detail>
          <Detail icon={Target} label="Who buys it" testId="opportunity-buyer">{profile.who_buys}</Detail>
        </div>
        <div>
          <Detail icon={MapPin} label="Where you sell it" testId="opportunity-channels">{profile.where_you_sell}</Detail>
          <Detail icon={RefreshCw} label="Revenue model" testId="opportunity-revenue">{profile.revenue_model}</Detail>
          <Detail icon={Sparkles} label="First customer" testId="opportunity-first-customer">{profile.first_customer_strategy}</Detail>
        </div>
      </div>

      {!compact && (
        <div className="grid border-t border-zinc-800 px-5 sm:grid-cols-2 sm:gap-x-8 sm:px-6">
          <Detail icon={Sparkles} label="Why now" testId="opportunity-why-now">{profile.why_now}</Detail>
          <Detail icon={Target} label="Competition / differentiation" testId="opportunity-differentiation">{profile.competition_differentiation}</Detail>
          <div className="sm:col-span-2"><Detail icon={RefreshCw} label="Scaling options" testId="opportunity-scaling">{profile.scaling_options}</Detail></div>
        </div>
      )}
    </section>
  );
};